import { warn } from "../../lib/log";
import { useEffect, useState } from "react";
import { createBoard, fetchBoard, submitEntry } from "../../lib/leaderboard";

// Group board state for the result screen: loads an existing board, creates one or joins it.
export const useLeaderboard = (boardCode, destinationIndex, onBoardCreated) => {
  const [board, setBoard] = useState(null);
  const [joined, setJoined] = useState(false);
  const [state, setState] = useState("idle"); // idle | loading | error

  useEffect(() => {
    if (!boardCode) return;
    fetchBoard(boardCode)
      .then(setBoard)
      .catch((e) => {
        warn("Classifica non disponibile", e);
        setState("error");
      });
  }, [boardCode]);

  const run = async (task) => {
    setState("loading");
    try {
      await task();
      setJoined(true);
      setState("idle");
    } catch (e) {
      warn("Operazione classifica non riuscita", e);
      setState("error");
    }
  };

  const join = (name) => run(async () => setBoard(await submitEntry(boardCode, name, destinationIndex)));

  const create = (name) =>
    run(async () => {
      const created = await createBoard(name);
      setBoard(await submitEntry(created.code, name, destinationIndex));
      onBoardCreated(created.code);
    });

  return { board, joined, state, join, create };
};
